<template>
  <div>
    <v-data-table :key="updater" :headers="headers" :items="federationUsers" sort-by="Id" class="elevation-1">
      <!-- Associate users in top datatable -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>

          <!-- Add users dialog -->
          <v-dialog v-model="dialog" fullscreen v-if="canManageCurrentFederation">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" @click="openAssociateUserDialog">Associer utilisateurs</v-btn>
            </template>
            <!--Partie de saisie du dialog-->
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col cols="12" sm="6" md="12">
                    <v-select
                      v-model="usersToAssociate"
                      label="Utilisateurs à associer"
                      :items="usersNotInFederation"
                      item-text="email"
                      item-value="id"
                      attach
                      chips
                      multiple
                      return-object
                      clearable
                      style="min-width: 200px"
                    ></v-select>
                  </v-col>
                </v-container>
              </v-card-text>
              <!--Fin du dialog-->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog()">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="associateUserToFederation(usersToAssociate)">Associer</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Actions on federation -->
      <template v-slot:[`item.actions`]="{ item }" v-if="canManageCurrentFederation">
        <v-icon @click="removeUserFromFederation(item.id)">mdi-power-plug-off</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  affectUsersToFederationAsync,
  removeUserFromFederationAsync,
  getUsersNotInFederationAsync,
  getFederationUsersAsync,
  getIsUserPartOfFederationAsync,
} from "../../api/federationsApi";
import store from "@/store";
import { VDataTable } from "vuetify/lib";
import PermissionsService from "@/services/PermissionsService";
import AuthService from "@/services/AuthService";

export default {
  components: {
    VDataTable,
  },

  props: {
    federationId_prop: Number,
  },

  data: () => ({
    pageLoaded: false,
    authService: AuthService,
    isCurrentUserPartOfFederation: false,
    federationId: null,
    dialog: false,
    headers: [
      // { text: "Id", value: "id", sortable: true },
      { text: "Email", value: "email", sortable: true },
      { text: "Prénom", value: "firstName", sortable: true },
      { text: "Nom", value: "lastName", sortable: true },
      { text: "Actions", value: "actions", sortable: false },
    ],
    usersToAssociate: [],
    federationUsers: [],
    editedIndex: -1,
    editedItem: {},
    usersNotInFederation: [],
    updater: 0,
  }),

  watch: {
    $route() {
      this.pageLoaded = false;
      this.initPage();
    },
    dialog(val) {
      val || this.closeDialog();
    },
  },

  computed: {
    canViewCurrentFederation() {
      return PermissionsService.FederationsPermissionsService.canViewOwnFederation;
    },
    canManageCurrentFederation() {
      // Can manage own federation and is part of current federation
      let canManageCurrentFederationAndIsPartOfCurrentFederation =
        PermissionsService.FederationsPermissionsService.canManageOwnFederation && this.isCurrentUserPartOfFederation;
        
      // Can manage all federations
      let canManageAllFederations = PermissionsService.FederationsPermissionsService.canManageAllFederations;

      let permission = canManageCurrentFederationAndIsPartOfCurrentFederation || canManageAllFederations;

      // If we don't have the permission to manage roles, we wanna remove the actions header from the datatable
      if (this.pageLoaded && !permission && this.headers.find((h) => h.text == "Actions")) {
        this.headers = this.headers.filter((h) => h.text != "Actions");
      }

      return permission;
    },
  },

  async mounted() {
    this.pageLoaded = false;
    await this.initPage();
  },

  methods: {
    async initPage() {
      // Override the props values from the url if provided
      this.federationId = this.$route.params.federationId ? parseInt(this.$route.params.federationId) : this.federationId_prop;

      // Check if the current user is part of current federation
      this.isCurrentUserPartOfFederation = await getIsUserPartOfFederationAsync(this.authService.userId, this.federationId);

      // Check if the user can see this page
      if (!this.canViewCurrentFederation) {
        store.dispatch("setSnackbar", {
          title: `Non Autorisé`,
          text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
          status: "warning",
          timeout: 2000,
        });

        this.$router.replace("/");
      }

      this.initializeList();

      this.pageLoaded = true;
    },

    // Get the federation's users and the list of users not in federation
    async initializeList() {
      // get the list of all users in order to provide it to the list of available user to add in the federation
      this.usersNotInFederation = await getUsersNotInFederationAsync(this.federationId);

      // Build the datatable values from the prop
      this.federationUsers = await getFederationUsersAsync(this.federationId);
    },

    // Associate a user to a federation
    async associateUserToFederation() {
      var usersToAssociateIds = this.usersToAssociate.map((u) => u.id);

      var result = await affectUsersToFederationAsync(this.federationId, usersToAssociateIds);

      if (result) {
        store.dispatch("setSnackbar", {
          title: "Utilisateur(s) associé(s)",
          text: "Les utilisateurs ont bien été associés à la fédération.",
          status: "success",
          timeout: 2000,
        });
      }

      this.closeDialog();

      await this.initializeList();
    },

    // Remove the association between the federation and the user
    async removeUserFromFederation(userId) {
      if (confirm("Etes-vous sûr de vouloir retirer cet utilisateur de la fédération ?")) {
        var result = await removeUserFromFederationAsync(this.federationId, userId);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Utilisateur retiré",
            text: "L'utilisateur a bien été retiré de la fédération.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // Open the associate user dialog
    openAssociateUserDialog() {
      this.dialog = true;
    },

    // Close the associate user dialog
    closeDialog() {
      this.dialog = false;
      this.usersToAssociate = [];
    },
  },
};
</script>
